import { Button } from 'components/ui/button';
import React from 'react';

const FormTwoSkeleton = () => {
  return (
    <div className="p-10 flex flex-col gap-[15px]">
      {/* heading */}
      <div className="text-left flex flex-col gap-1/2">
        <h3 className="text-[#202020] text-[14px] uppercase font-semibold">
          Step 2
        </h3>
        <h1 className="text-[28px] font-bold">Select Services</h1>
      </div>

      {/* inputs */}
      <div className="flex flex-col gap-1">
        <div className="flex flex-row gap-2 items-center">
          <span className="text-[#846CEC] text-[16px]">Select all</span>
          <input
            title="all"
            disabled
            type="checkbox"
            className="h-4 w-4 checked:bg-[#846CEC] border-input rounded-md focus:outline-none focus:ring-0 focus:border-0 checked:focus:bg-[#846CEC]"
          />
        </div>
        <div className="grid grid-rows-5 grid-cols-2 grid-flow-col gap-4 w-[660px]">
          {Array(10)
            .fill(1)
            .map((_, idx) => {
              return (
                <div
                  key={idx}
                  className="w-[250px] bg-gray-300 h-12 animate-pulse rounded-md"
                />
              );
            })}
        </div>
      </div>

      <div className="flex justify-end w-full">
        <Button
          disabled
          variant="customPrimary"
          className="max-w-fit text-[16px]"
        >
          Create Telegram Bot
        </Button>
      </div>
    </div>
  );
};

export default FormTwoSkeleton;
